import { Theme } from '@wds/styles';
import { Palette as PricingPalette, PackageColors } from './colors';

import { PACKAGES } from '~pricing/lib/constants';

type PackageThemeOptions<T> = {
  [P in 'primary']: T;
};
export type PackageTheme = Record<string, PackageThemeOptions<{} | string>>;

// Any theme object we expose show be define here by its type or interface
type PricingTheme = {
  pricingPalette: PricingPalette;
  packageColors: PackageColors;
  packageTheme: PackageTheme;
};

export type PricingAppTheme = Theme & PricingTheme;

const pricingPalette: Required<PricingPalette> = {
  colors: {
    sabaeus: '#00BF6F',
    midnight: '#05467E',
    link: '#007FAA',
    arctic: '#2DCCD3',
    concord: '#671E75',
    raspberry: '#AC145A',
    bengal: '#F05B24',
    bumblebee: '#F9BE00',
    black: '#000000',
    charcoal: '#333E48',
    slate: '#6B787F',
    stone: '#9DA5AA',
    flint: '#D0D2D3',
    pebble: '#EDEEEE',
    canvas: '#F7F8FA',
    white: '#FFFFFF',
  },
};

export const packageColors: PackageColors = {
  advantageAnnual: pricingPalette.colors.sabaeus,
  analyze: pricingPalette.colors.raspberry,
  enterprise: pricingPalette.colors.midnight,
  premierAnnual: pricingPalette.colors.midnight,
  standardMonthly: pricingPalette.colors.arctic,
  teamAdvantage: pricingPalette.colors.link,
  teamPremier: pricingPalette.colors.concord,
};

export const packageTheme: PackageTheme = {
  [PACKAGES.AdvantageAnnual]: {
    primary: packageColors.advantageAnnual,
  },
  [PACKAGES.Enterprise]: {
    primary: packageColors.enterprise,
  },
  [PACKAGES.PremierAnnual]: {
    primary: packageColors.premierAnnual,
  },
  [PACKAGES.StandardMonthly]: {
    primary: packageColors.standardMonthly,
  },
  [PACKAGES.TeamAdvantage]: {
    primary: packageColors.teamAdvantage,
  },
  [PACKAGES.TeamPremier]: {
    primary: packageColors.teamPremier,
  },
};

export function getPricingTheme(): PricingTheme {
  return {
    pricingPalette, // User defined theme
    packageColors,
    packageTheme,
  };
}
